
























import Vue from 'vue'
import ConfirmButtons from '@/components/ConfirmButtons.vue'
import Dialog from './Dialog.vue'

export default Vue.extend({
  components: {
    appConfirmButtons: ConfirmButtons,
    appDialog: Dialog,
  },
  props: {
    loading: Boolean,
    prev: {
      required: false,
      default: true,
      type: Boolean,
    },
    next: {
      required: false,
      default: true,
      type: Boolean,
    },
    acceptText: String,
    cancelText: String,
  },
})
